export type Mm2AppearancePart = "Character" | "Hair Style" | "Hair Color" | "Face";

export type Mm2TextureSlot = {
  part: Mm2AppearancePart;
  character: number;
  option: number;
  status: "confirmed" | "unresolved";
  packageEntry?: number;
  transfer?: number;
  tbp0?: number;
  width?: number;
  height?: number;
  psm?: number;
  pixelPayloadOffset?: number;
  pixelByteLength?: number;
  notes: string;
};

// Machine-readable appearance map for the MM2 USA player customization bank.
// Keep verified disc/runtime facts here so diagnostic packs and future authored
// GenieWoman mod packs do not grow separate copies of binary magic numbers.
export const MM2_USA_APPEARANCE_SLOTS: readonly Mm2TextureSlot[] = [
  {
    part: "Face",
    character: 1,
    option: 1,
    status: "confirmed",
    packageEntry: 2,
    transfer: 289,
    tbp0: 0x33fb,
    width: 64,
    height: 64,
    psm: 0x14,
    pixelPayloadOffset: 0x1962b0,
    pixelByteLength: (64 * 64) / 2,
    notes: "Confirmed by runtime differential probe and on-disc payload correlation.",
  },
  {
    part: "Character",
    character: 1,
    option: 1,
    status: "unresolved",
    notes: "Next differential-correlation target. Preserve the native player skeleton until model/rig mapping is proven.",
  },
  {
    part: "Hair Style",
    character: 1,
    option: 1,
    status: "unresolved",
    notes: "Next differential-correlation target; may be texture, geometry, or material/palette driven.",
  },
  {
    part: "Hair Color",
    character: 1,
    option: 1,
    status: "unresolved",
    notes: "Next differential-correlation target; likely palette/material driven if TEX0 remains stable.",
  },
] as const;

export const MM2_USA_CHARACTER1_FACE1 = MM2_USA_APPEARANCE_SLOTS[0];

export function confirmedAppearanceSlots(): readonly Mm2TextureSlot[] {
  return MM2_USA_APPEARANCE_SLOTS.filter((slot) => slot.status === "confirmed");
}

export function unresolvedAppearanceSlots(): readonly Mm2TextureSlot[] {
  return MM2_USA_APPEARANCE_SLOTS.filter((slot) => slot.status === "unresolved");
}
